import {
  USER_LOGIN,
  USER_RESET_OTP_VALIDATE,
  USER_RESET_OTP_SEND,
  LOGOUT,
  FETCH_ROLE_DATA,
  REFRESH,
  FETCH_PROFILE,
  USER_ROLES,
  GENERATE_TOKEN,
  SSO_LOGIN,
} from '../../resources/endPoint';

export const getUserLogin = data => {
  return {
    url: USER_LOGIN,
    payload: data,
    method: 'post',
    //   tag: ApiTag.CSRF_TOKEN,
    headers: {'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
  };
};

export const ssoLogin = data => {
  return {
    url: SSO_LOGIN,
    payload: data,
    method: 'post',
    //   tag: ApiTag.CSRF_TOKEN,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
  };
};

export const validateOtp = data => {
  return {
    url: USER_RESET_OTP_VALIDATE,
    payload: data,
    method: 'post',
    //   tag: ApiTag.CSRF_TOKEN,
    headers: {'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
  };
};

export const sendOtp = data => {
  return {
    url: USER_RESET_OTP_SEND,
    payload: data,
    method: 'post',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: false,
    csrfToken: true,
  };
};

export const logoutApi = data => {
  return {
    url: LOGOUT,
    payload: data,
    method: 'post',
    tag: LOGOUT,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
  };
};
export const roleData = data => {
  return {
    url: FETCH_ROLE_DATA,
    payload: data,
    method: 'post',
    //    tag: ApiTag,
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
  };
};
export const refreshApi = data => {
  return {
    url: REFRESH,
    payload: data,
    method: 'post',
    tag: REFRESH,
    headers: {'content-type': 'application/json'},
    authRequired: false,
    tokenExpiry: true,
  };
};

export const fetchProfileData = data => {
  return {
    url: FETCH_PROFILE,
    payload: data,
    method: 'post',
    tag: 'FETCH_PROFILE',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'user-service',
  };
};
export const fetchUserRoles = data => {
  return {
    url: USER_ROLES,
    payload: data,
    method: 'get',
    tag: 'FETCH_PROFILE',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'user-service',
  };
};

export const generateTokenRole = data => {
  return {
    url: GENERATE_TOKEN,
    payload: data,
    method: 'post',
    tag: 'FETCH_PROFILE',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: true,
    service: 'user-service',
  };
};
